import BaseSearchOptions from './_baseSearchOptions'
import mxcategoryItems from 'vue-src/store/modules/persistent/modules/mxcategoryItems'
import categories from 'vue-src/store/modules/persistent/modules/categories'
import items from 'vue-src/store/modules/persistent/modules/items'

export default BaseSearchOptions({
  modules:{
    mxcategoryItems,
    categories,
    items,
  },
})


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/persistent/modules/search.js